<scitis-app-global-page-header [pageTitle]="'Connections'">
</scitis-app-global-page-header>

<ul #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs" ngbNav>
  <li [ngbNavItem]="1">
    <a ngbNavLink translate>Aliases</a>
    <ng-template ngbNavContent>
      @if (gatewaySignals.length) {
        <scitis-admin-gateway-aliases
          [gatewaySignals]=gatewaySignals
          [gateway]="gateway"
          [isArgosGateway]="isArgosGateway"
          [isGeneric]="isGenericGateway"
          [isEavViewFeatureEnabled]="isEavViewFeatureEnabled"
          [isEditable]="isEditable"
          [isStreamingEventDataToPubSubFeatureEnabled]="isStreamingEventDataToPubSubFeatureEnabled"
          [isAdminOrHigher]="isAdminOrHigher"
          [superOrTechAdminRole]="superOrTechAdminRole">
        </scitis-admin-gateway-aliases>
      }
    </ng-template>
  </li>

  <li [ngbNavItem]="2">
    <a ngbNavLink translate>Arrays</a>
    <ng-template ngbNavContent>
      <div class="text-right mb-3">
        @if (superOrTechAdminRole) {
          <button (click)="onSaveArrays()"
            [disabled]="!superOrTechAdminRole || !arraysConfigChanged"
            class="btn btn-primary">
            <span class="hidden-xs" translate>Save arrays configuration</span>
          </button>
        }
      </div>
      <scitis-admin-gateway-arrays
        (arraysChangedEvent)="arraysConfigChanged=$event"
        [gatewaySignals]="gatewaySignals"
        [isEditable]="isEditable"
        [superOrTechAdminRole]="superOrTechAdminRole">
      </scitis-admin-gateway-arrays>
    </ng-template>
  </li>

</ul>

<div class="card card-tab-container">
  <div [ngbNavOutlet]="nav" class="card-body"></div>
</div>
